import { Component, OnInit } from '@angular/core';
import { ClaimTypes } from 'src/app/core/enums/claim-type.enum';
import { AuthAction } from 'src/app/store/auth/auth.action';
import { environment } from 'src/environments/environment';
import { SettingsAction } from 'src/app/store/settings/settings.action';
import { SettingsState } from 'src/app/store/settings/settings.state';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation.service';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';
import { appInfo } from 'src/app/shared/constants/app-info.constant';
import { StoreHelperService } from 'src/app/shared/services/store-helper/store-helper.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
})
export class ContentLayoutComponent implements OnInit {
  routeMetaData = routeMetaData;
  appInfo = appInfo;
  fullName!: string;
  isTestMode = environment.testEnvironment;
  version: string = '';

  constructor(
    private authService: AuthService,
    private navigation: NavigationService,
    private storeHelperService: StoreHelperService
  ) {}

  ngOnInit(): void {
    this.getVersion();
    this.getDetails();
  }

  getVersion(): void {
    this.storeHelperService
      .getAllDispatchAndSelect(
        new SettingsAction.GetAppInfo(),
        SettingsState.getAppInfo
      )
      .pipe(
        tap((data) => {
          this.version = data?.version ?? '';
        })
      )
      .subscribe();
  }

  getDetails() {
    const decodedToken: any = this.authService.decodedToken();

    if (decodedToken) {
      const givenName = decodedToken[ClaimTypes.UserName];
      const surname = decodedToken[ClaimTypes.Surname];
      this.fullName = `${givenName} ${surname}`;
    }
  }

  logout() {
    this.storeHelperService
      .getAllDispatchAndSelect(AuthAction.Logout)
      .pipe(
        tap((data) => {
          this.navigation.goToLogin();
        })
      )
      .subscribe();
  }
}
